import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tache-by-user',
  templateUrl: './tache-by-user.component.html',
  styleUrls: ['./tache-by-user.component.css']
})
export class TacheByUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
